
<app-chart-select-widget-library [clientStudyData]="clientStudyData"></app-chart-select-widget-library>

